import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  LOCALE_ID,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { cleanupInterceptor } from './core/interceptors/cleanup.interceptor';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { MyPreset } from './config/primeng-theme';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { registerLocaleData } from '@angular/common';
import localeZhHant from '@angular/common/locales/zh-Hant';

import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

registerLocaleData(localeZhHant, 'zh-TW');

console.log('MyPreset', MyPreset);
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([cleanupInterceptor, apiInterceptor])),
    providePrimeNG({
      overlayAppendTo: 'body',
      csp: {
        nonce: document.querySelector('app-root')?.getAttribute('ngCspNonce') ?? undefined,
      },
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.p-dark'
        }
      }
    }),
    { provide: LOCALE_ID, useValue: 'zh-TW' },
    MessageService
  ],
};
